import { domShowObserve } from '../../../utils/index.js';
import { showFeedBury } from '../bury';
export default {
  props: {
    index: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.showHandle();
    });
  },
  methods: {
    showHandle() {
      if (!this.$refs.middleDom || !IntersectionObserver) {
        return;
      }
      domShowObserve(this.$refs.middleDom, dom => {
        var _dom$dataset;
        const index = (dom === null || dom === void 0 || (_dom$dataset = dom.dataset) === null || _dom$dataset === void 0 ? void 0 : _dom$dataset.rank) || -1;
        showFeedBury(index, 'middle');
      }, {}, 'middle-dom');
    }
  }
};